import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import DoDontCards from '../../components/DoDontCards';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import IllustrationBg from '../../../../../../assets/civil/frameworks/illustrationBg.png';

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[2],
    [settings?.paragraphs]
  );

  const handleIntroComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-frameworks-section2-1');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="frameworks-section">
      <div className="content-block content-block-intro">
        <ExpandableListIllustration
          id="civil-frameworks-section2-1"
          mainTitle={paragraphSettings?.introTitle}
          subTitle={paragraphSettings?.introSubTitle}
          description={paragraphSettings?.introDesc}
          illustration={<img src={IllustrationBg} alt="" />}
          items={(paragraphSettings?.introItems || []).map((item: any) => ({
            title: item.title || '',
            content: item.content || '',
          }))}
          onComplete={handleIntroComplete}
        />
      </div>
      <div className="content-block content-block-g3">
        <NumberedStepsCarousel
          type="simple"
          mainTitle={paragraphSettings?.g3Title}
          description={paragraphSettings?.g3Desc}
          items={(paragraphSettings?.g3Items || []).map((item: any) => ({
            text: item.text || '',
          }))}
          defaultActive={0}
        />
      </div>
      <div className="content-block content-block-dodont">
        <div className="cb-header">
          {paragraphSettings?.section1Title && (
            <h2 className="cb-title">{paragraphSettings.section1Title}</h2>
          )}
        </div>
        <DoDontCards
          doColumn={paragraphSettings?.doColumn}
          dontColumn={paragraphSettings?.dontColumn}
        />
      </div>
    </div>
  );
};

export default Section2;
